import template from './head.html'
import ko from 'knockout'
import eventlistener from '../../util/eventlistener'
function _init (params, componentInfo) {
  this.setCellWidth = function () { return '200' }
  this.columns = params.columns
  let _columns = params.convertedColumns
  this.convertedColumns = ko.observableArray(_columns())
  this.triggerReset = params.triggerReset
  this.columns1 = params.columns1 || ko.observableArray([])
  // 用于多行的rowspan
  this.columns2 = params.columns2 || ko.observableArray([])
  this.tableWidth = params.tableWidth
  this.hasVerticalSroll = params.hasVerticalSroll || ko.observable(false)
  this.compoutedTableWidth = ko.computed(() => {
    if (!this.tableWidth) {
      return ''
    }
    var width = this.tableWidth()
    var hasScroll = this.hasVerticalSroll()
    if (width === '100%' && hasScroll) {
      return 'calc(100% - 15px)'
    } else {
      return width
    }
  })
  this.el = params.el
  this.outterWidth = ko.observable()
  this.headHeight = null
  if (ko.unwrap(params.lockcolumn)) {
    if (!params.maintable) {
      this.headHeight = params.headHeight
    }
  } else {
    this.headHeight = params.headHeight
  }
  let nowOuterWidth = 0
  let nowHeaderHeight = 0
  var loopCount = 0
  var _interval = null
  var recaculateHeader = () => {
    _interval = setInterval(() => {
      window.requestAnimationFrame(() => {
        if (params.el) {
          if (loopCount > 10) {
            _interval && clearInterval(_interval)
            loopCount = 0
          } else {
            loopCount++
          }
          var width = params.el.firstElementChild.offsetWidth
          var height = componentInfo.element.firstElementChild.offsetHeight
          // 对于多级表头+lockhead/lockcolumn的情况，body的margin-top需要动态计算
          if (nowHeaderHeight !== height) {
            if (this.headHeight) {
              nowHeaderHeight = height
              this.headHeight(height + 'px')
            }
          }
          // 对于在modal中的grid需要特殊处理
          if (nowOuterWidth !== width) {
            this.triggerReset && this.triggerReset(!this.triggerReset())
            nowOuterWidth = width
            if (width > 0) {
              this.outterWidth(width - 1 + 'px')
            } else {
              this.outterWidth('100%')
            }
          }
        }
      })
    }, 500)
  }
  if (params.lockhead) {
    recaculateHeader()
  }
  typeof params.convertedColumns === 'function' && params.convertedColumns.subscribe(cols => {
    this.convertedColumns(cols)
    this.convertedColumns.splice(0, 0)
    if (cols && cols.length > 0) {
      recaculateHeader()
    }
  })
  this.allRowChecked = params.allRowChecked
  this.lockhead = params.lockhead
  this.headtransform = params.headtransform
  if (params.groupSort) {
    if (params.groupSort()) {
      this.holdKeyInstance = eventlistener.addKeyHoldListener()
    } else {
      params.groupSort.subscribe((val) => {
        if (val) {
          this.holdKeyInstance = eventlistener.addKeyHoldListener()
        } else {
          this.holdKeyInstance = null
        }
      })
    }
  }
  this.onHeadKeyDown = function (e) {
    debugger
  }
  // 排序算法回调
  this.handleSort = (vm, event) => {
    if (vm.sort) {
      let node = event.currentTarget
      var holdKey = this.holdKeyInstance && this.holdKeyInstance.get()
      // 如果启用了组合
      if (holdKey && holdKey.length > 0) {
        this.groupSortField = this.holdKeyInstance.getGroupSortField()
        // ctrl(windows) 或 commnad(mac)
        if (this.holdKeyInstance.isHoldKeyCode(17) || this.holdKeyInstance.isHoldKeyCode(91)) {
          let existIndex = this.groupSortField.indexOf(vm.field)
          // 如果已经选过了 再选那么要重新排序
          if (existIndex < 0) {
            this.holdKeyInstance.addGroupSortField(vm.field)
            this.holdKeyInstance.addSortType('asc')
          } else {
            if (node.classList.contains('y-sort-asc')) {
              this.holdKeyInstance.setSortTypeByIndex(existIndex, 'desc')
            } else {
              this.holdKeyInstance.setSortTypeByIndex(existIndex, 'asc')
            }
          }
          this.el.querySelectorAll('.y-cell-sortable').forEach(element => {
            let index = this.groupSortField.indexOf(element.attributes['data-key'].value)
            if (index >= 0) {
              element.querySelector('.sort-index').innerText = index + 1
            } else {
              element.querySelector('.sort-index').innerText = ''
            }
            if (node !== element && index < 0) {
              element.classList.remove('y-sort-asc')
              element.classList.remove('y-sort-desc')
            }
          })
        }
        this.sortType = this.holdKeyInstance.getSortType()
      } else {
        if (this.holdKeyInstance) {
          this.holdKeyInstance.setGroupSortField([])
          this.holdKeyInstance.setSortType([])
        }
        // 同一个表格排序以前需要把其他排序列的标识先清空
        this.el.querySelectorAll('.y-cell-sortable').forEach(element => {
          element.querySelector('.sort-index').innerText = ''
          if (node !== element) {
            element.classList.remove('y-sort-asc')
            element.classList.remove('y-sort-desc')
          }
        })
      }
      if (this.holdKeyInstance) {
        this.sortType = this.holdKeyInstance.getSortType()
        this.groupSortField = this.holdKeyInstance.getGroupSortField()
      }
      // 设置当前列的升序,降序
      if (node.classList.contains('y-sort-asc')) {
        node.classList.add('y-sort-desc')
        node.classList.remove('y-sort-asc')
        vm.sortFn && vm.sortFn('desc', this.groupSortField, this.sortType)
      } else {
        node.classList.add('y-sort-asc')
        node.classList.remove('y-sort-desc')
        vm.sortFn && vm.sortFn('asc', this.groupSortField, this.sortType)
      }
    }
  }
}
var init = {
  createViewModel: function (params, componentInfo) {
    return new _init(params, componentInfo)
  }
}
export default {
  name: 'grid-head',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/grid/head.js